'use strict';

import React from 'react';
import LabelClaro from './LabelClaro';


class RadioGroupClaro extends React.Component{

    constructor(){
        super();
    }

    render() {
        let wrapperClass = this.props.componentWrapperClassName;
        if(this.props.error && this.props.error.length > 0){
            wrapperClass += " has-error";
        }
        return (
            <div className={wrapperClass}>
                <div className={this.props.labelClassName}>
                    <LabelClaro htmlFor={this.props.idElement} labelText={this.props.labelText} labelTip={this.props.labelTip} className={this.props.labelClassName} />
                </div>
                <div className={this.props.childrenClassName}>
                    { this.props.children }
                    <br />
                    <span className="help-block error-wrapper error-empty">{this.props.error}</span>
                </div>
            </div>
        );
    }
}

RadioGroupClaro.defaultProps = {
    componentWrapperClassName: "form-group",
    labelClassName: "col-sm-4 col-xs-4 control-label",
    childrenClassName: "col-sm-8 col-xs-8"
}

export default RadioGroupClaro;